import { isProduction } from '../environment';
import { UserApi as RealUserApi } from './user-api';
import { UserApi as MockUserApi } from './mock-user-api';

// Select the concrete implementation based on environment.
const SelectedUserApi = isProduction() ? RealUserApi : MockUserApi;

export default SelectedUserApi;